import { useMergeRefs } from "@floating-ui/react";
import { forwardRef, HTMLProps } from "react";
import { usePopoverContext } from "../../hooks/usePopover";

export const PopoverTrigger = forwardRef<HTMLElement, HTMLProps<HTMLElement>>(
  ({ children, ...props }, propRef) => {
    const context = usePopoverContext();
    const ref = useMergeRefs([context.refs.setReference, propRef]);

    return (
      <div
        ref={ref}
        data-state={context.open ? "open" : "closed"}
        {...context.getReferenceProps(props)}
      >
        {children}
      </div>
    );
  },
);

PopoverTrigger.displayName = "PopoverTrigger";
